import { types } from '../actions/locations';

const initialState = {
  suggestions: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SMART_LOCATIONS_PENDING:
      return {
        pendingLocation: true,
        suggestions: {}
      };
    case types.FETCH_SMART_LOCATIONS_FULFILLED:
      return {
        ...state,
        suggestions: [
          ...action.payload.Data.map((location) => ({
            location: `${location.CityName}, ${location.StateName}, ${location.CountryName}`
          }))
        ],
        pendingLocation: false
      };
    default:
      return state;
  }
}
